import React from 'react';
//import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

//import './index.css';
import App from './app';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);
//ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// https://dev.to/rogeliosamuel621/react-without-create-react-app-webpack-5-1b1o
//module.hot.accept();
